import { c as _c } from "react/compiler-runtime";
import { FormSelect, PrimaryButton } from '@systemeio/ui';
import { addCourse } from 'modules/courses/bundles/course-bundle/api/course-bundle-api';
import { useCoursesList } from 'modules/courses/bundles/course-bundle/hooks/use-courses-list';
import { CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface';
import React, { useState } from 'react';
import CreateModal from 'shared/components/create-modal';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { AddIcon } from '@systemeio/ui/icons';
interface AddCourseEditInterface {
  course?: number;
}
const defaultValues: AddCourseEditInterface = {
  course: undefined
};
interface AddCourseModalProps {
  addCourseWithUpdate: (course: CourseBundleItemInterface) => Promise<void>;
  courseBundleId: string;
  disabled: boolean;
  withIcon?: boolean;
}
const AddCourseModal = t0 => {
  const $ = _c(34);
  const {
    addCourseWithUpdate,
    courseBundleId,
    disabled,
    withIcon: t1
  } = t0;
  const withIcon = t1 === undefined ? true : t1;
  const {
    t
  } = useLocoTranslation();
  const [opened, setOpened] = useState(false);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setOpened(false);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const onClose = t2;
  const {
    courseList,
    mutate: mutateCourseList
  } = useCoursesList(courseBundleId);
  let t3;
  if ($[1] !== addCourseWithUpdate || $[2] !== courseBundleId || $[3] !== courseList || $[4] !== mutateCourseList) {
    t3 = async data => {
      const courseInfo = courseList?.find(course => course.id === data.course);
      if (courseInfo) {
        const newCourseData = {
          course: courseInfo.id
        };
        ;
        try {
          const response = await addCourse(courseBundleId, newCourseData);
          const addedCourseBundleItem = {
            id: response.data.id,
            delayBeforeStart: 0,
            course: {
              id: response.data.course.id,
              name: response.data.course.name
            }
          };
          await addCourseWithUpdate(addedCourseBundleItem);
          await mutateCourseList(data_0 => {
            if (data_0) {
              return data_0.filter(course_0 => course_0.id !== response.data.course.id);
            }
          }, false);
        } catch (t4) {
          const e = t4;
          throw e;
        }
      }
    };
    $[1] = addCourseWithUpdate;
    $[2] = courseBundleId;
    $[3] = courseList;
    $[4] = mutateCourseList;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const onCreate = t3;
  let t4;
  if ($[6] !== courseList) {
    t4 = courseList?.map(_temp);
    $[6] = courseList;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const courseSelectData = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpened(true);
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !courseList;
  const t7 = `${withIcon ? "block" : "lg:hidden"} block`;
  let t8;
  if ($[9] !== t7) {
    t8 = <AddIcon className={t7} />;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t) {
    t9 = t("dashboard.course_bundle.add_course_title");
    $[11] = t;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t9) {
    t10 = <span className="hidden whitespace-nowrap lg:block">{t9}</span>;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== disabled || $[16] !== t10 || $[17] !== t6 || $[18] !== t8) {
    t11 = <PrimaryButton disabled={disabled} className="flex items-center justify-between" onClick={t5} isFetching={t6}>{t8}{t10}</PrimaryButton>;
    $[15] = disabled;
    $[16] = t10;
    $[17] = t6;
    $[18] = t8;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t) {
    t12 = t("dashboard.course_bundle.add_course_title");
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== courseSelectData || $[23] !== t) {
    t13 = [{
      field: "course",
      onRender: (value, onChange) => <FormSelect key="course-selector" data={courseSelectData} placeholder={t("dashboard.course_bundle.choose_course")} value={value} onChange={data_1 => onChange(data_1)} />
    }];
    $[22] = courseSelectData;
    $[23] = t;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = ["course"];
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== onCreate || $[27] !== opened || $[28] !== t12 || $[29] !== t13) {
    t15 = <CreateModal opened={opened} onClose={onClose} defaultValues={defaultValues} fullCaption={t12} creatable={t13} onCreate={onCreate} requiredFields={t14} needToast={false} />;
    $[26] = onCreate;
    $[27] = opened;
    $[28] = t12;
    $[29] = t13;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t11 || $[32] !== t15) {
    t16 = <>{t11}{t15}</>;
    $[31] = t11;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};
export default AddCourseModal;
function _temp(course_1) {
  return {
    id: course_1.id,
    caption: course_1.name
  };
}